<h3 mat-dialog-title>{{data.title ?? 'Confirmation Check'}}</h3>
<div mat-dialog-content>
  <p>{{data.description ?? 'Are you sure you would like to perform this action?'}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">{{data.cancelButtonText ?? 'Cancel'}}</button>
  <button mat-button [mat-dialog-close]="true">{{data.confirmationButtonText ?? 'Confirm'}}</button>
</div>